import { useEffect, useState } from 'react'
import { Outlet, Navigate } from 'react-router-dom'
import AppLoading from 'containers/App/AppLoading'
import AppTheme from 'containers/App/AppTheme'
import globalStore from 'store'
import Services from 'services'
import { IResponsePlan } from 'models/response.plan.model'

const ProtectByResponsePlanByUser = () => {
  const user = globalStore(state => state.user)

  const [isLoadingState, setIsLoadingState] = useState(false)
  const [responsePlan, setResponsePlan] = useState<IResponsePlan | undefined>(undefined)

  useEffect(() => {
    const getResponsePlan = async () => {
      Services.ResponsePlan.getResponsePlan()
        .then(response => {
          setResponsePlan(response)
        })
        .finally(() => {
          setIsLoadingState(false)
        })
    }
    setIsLoadingState(true)
    getResponsePlan()
  }, [])

  if (!user || isLoadingState) {
    return (
      <AppTheme>
        <AppLoading />
      </AppTheme>
    )
  }

  return !responsePlan ? <Outlet /> : <Navigate to="/" />
}

export default ProtectByResponsePlanByUser
